import { logger } from '@adornis/base/logging.js';
import { registerMutation, registerQuery } from '@adornis/baseql/metadata/register.js';
import { getNextWorkingDay } from '../../imac/get-next-work-day.js';
import { runDellChecksumObservation } from '../server/checksum-observation-runner.js';
import { runOutboundPudoPickup as runOutboundPudoPickupServer } from '../server/outbound-pudo/runner.js';
import { runSendEmailPartExchange as runSendEmailPartExchangeServer } from '../server/part-exchange-send-email.js';
import { rerunRouteOptimizationFromResultData } from '../server/rerun-route-optimization-from-result-data.js';
import { assertNexusSchedulingMutationAllowed } from './assert-nexus-scheduling-access.js';
import { updateSchedulingState } from './subscribe-scheduling-state.js';

let dellChecksumObservationPromise: Promise<any> | null = null;

export const runManualChecksum = registerMutation({
  operationName: 'runManualChecksum',
  type: () => Boolean,
  resolve: () => async () => {
    logger.info('debug: runManualChecksum mutation start');
    await assertNexusSchedulingMutationAllowed();
    if (dellChecksumObservationPromise) throw new Error('Checksum Aggregation already running');
    dellChecksumObservationPromise = runDellChecksumObservation()
      .then(async checksumObservation => {
        return checksumObservation
          ? await rerunRouteOptimizationFromResultData(
              checksumObservation._id,
              await getNextWorkingDay(new Date()),
              `rerun-${checksumObservation._id}`,
            )
          : null;
      })
      .catch(err => {
        logger.error({ err }, 'ERROR RUNNING MANUAL CHECKSUM');
        updateSchedulingState({
          phase: 'error',
          message: 'Error running manual checksum',
        });
      })
      .then(() => (dellChecksumObservationPromise = null));
    return true;
  },
  params: [],
});

export const waitForManualChecksumToFinish = registerQuery({
  operationName: 'waitForManualChecksumToFinish',
  type: () => Boolean,
  resolve: () => async () => {
    if (!dellChecksumObservationPromise) return false;
    await dellChecksumObservationPromise;
    return true;
  },
  params: [],
});

export const runOutboundPudoPickup = registerMutation({
  operationName: 'runOutboundPudoPickup',
  type: () => String,
  resolve: () => async () => {
    await assertNexusSchedulingMutationAllowed();
    return await runOutboundPudoPickupServer();
  },
  params: [],
});

export const runSendEmailPartExchange = registerMutation({
  operationName: 'runSendEmailPartExchange',
  type: () => String,
  resolve: () => async () => {
    const result = await runSendEmailPartExchangeServer();
    if (typeof result === 'string') return result;
    return `Send email part exchange processed ${result?.ticketsProcessed ?? 0} ticket(s), sent ${result?.emailsSent ?? 0} email(s), skipped ${result?.ticketsSkipped ?? 0}.`;
  },
  params: [],
});
